<template>
	<component :is="tag" class="button" :class="{loading, disabled}" @click="$emit('click')">
		<slot/>
	</component>
</template>

<script>
export default {
	props: {
		loading: {type: Boolean, required: false},
		disabled: {type: Boolean, required: false},
		tag: {type: String, default: 'a'}
	}
};
</script>

<style  lang="scss" scoped>
.button {
	outline: none;
	user-select: none;
	border: 1px solid #22313A;
	display: inline-flex;
	background-color: #22313A;
	color: $white1;
	height: 32px;
	padding: 0 40px;
	font-weight: 300;
	align-items: center;
	justify-content: center;
	text-align: center;
	transition: cubic(opacity, 0.1s);
	cursor: pointer;

	&.loading, &.disabled {
		pointer-events: none;
		opacity: 0.3;
	}
}
</style>
